/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {AccountingService} from './accounting.service';
import {AccountingMappingComponent} from './accouting-mapping/accounting-mapping.component';

import {TabsModule} from 'ngx-bootstrap/tabs';
import {ChartsModule} from '../charts/charts.module';
import {FormGeneratorModule} from '../form-generator/form-generator.module';
import {ModalModule} from '../modal/modal.module';
import {PipesModule} from '../pipes/pipes.module';
import {TreeDiagramModule} from '../tree-diagram/tree-diagram.module';
import {UiModule} from '../ui/ui.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TabsModule.forRoot(),
    ChartsModule,
    UiModule,
    PipesModule,
    ModalModule,
    TranslateModule,
    TreeDiagramModule,
    FormGeneratorModule,
    RouterModule
  ],
  declarations: [
    AccountingMappingComponent
  ],
  exports: [
    AccountingMappingComponent
  ]
})
export class AccountingModule {
  public static forRoot(): ModuleWithProviders<AccountingModule> {
    return {
      ngModule: AccountingModule,
      providers: [
        AccountingService
      ]
    };
  }
}
